var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4016 7.99961C14.4016 11.5342 11.5362 14.3996 8.00156 14.3996C4.46694 14.3996 1.60156 11.5342 1.60156 7.99961C1.60156 4.46499 4.46694 1.59961 8.00156 1.59961C11.5362 1.59961 14.4016 4.46499 14.4016 7.99961ZM10.7828 11.9122C9.99818 12.471 9.03825 12.7996 8.00156 12.7996C5.3506 12.7996 3.20156 10.6506 3.20156 7.99961C3.20156 6.96292 3.53021 6.00299 4.089 5.21832L10.7828 11.9122ZM11.9142 10.7808L5.22039 4.08697C6.00504 3.52823 6.96492 3.19961 8.00156 3.19961C10.6525 3.19961 12.8016 5.34864 12.8016 7.99961C12.8016 9.03625 12.4729 9.99613 11.9142 10.7808Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/Closed.1d4ab5f8b021986e1fe005e34fdabcc1.svg";
export { ForwardRef as ReactComponent };